/* eslint-disable no-restricted-globals */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/named */
/* eslint-disable prefer-template */
/* eslint-disable one-var */
/* eslint-disable radix */
/* eslint-disable no-else-return */
// eslint-disable-next-line no-plusplus
/* eslint-disable no-shadow */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-var */
/* eslint-disable camelcase */
/* eslint-disable react/no-array-index-key */
/* eslint-disable arrow-body-style */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-const */
/* eslint-disable dot-notation */
// eslint-disable-next-line no-plusplus
/* eslint-disable no-nested-ternary */
// eslint-disable-next-line spaced-comment
// eslint-disable-line no-plusplus
// eslint-disable-next-line spaced-comment
// eslint-disable-next-line spaced-comment
import React, { useState, useEffect } from "react";
import {useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import DeleteIcon from "@material-ui/icons/Delete";
import axios from "axios";
import {
  Grid,
  IconButton,
} from "@material-ui/core";
import clsx from "clsx";
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import Select from "react-select";
import moment from "moment";
import { setLogin } from '../../redux/features/auth/actions';
import styles from "./BatchTimeBooking.module.css";
import {
  CustomFormGroup,
  CustomSelect,
  CustomDatePicker,
  ValidatingTextField,
} from "../../components/FormComponents";
import BackButton from "../../components/BackButton/BackButton";
import {
  DATE_FORMAT,
  API_RESOURCE_URLS,
  DISPLAY_MESSAGES,
  MESSAGE_TYPE,
  RESOURCE_TYPE,
  USER_OPERATIONS,
  Regex,
} from "../../constants";
import { withAllowedOperationsProvider } from "../../hocs";
import { CustomTab, Button, AuthChecker } from "../../atomicComponents";
import UserInfoPanel from "../../atomicComponents/UserInfoPanel/UserInfoPanel";
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import TableSimple from "../../atomicComponents/TableSimple1/TableSimple";
import Truckloading from "../../components/CvLoader/Cvloader";
import apiService from "../../apis/apiService";
import { sanitizeCoCodeNumeric, sanitizeNumeric } from "../../utils/utils";

const BatchTimeBooking = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [sessionData, setSessionData] = useState([]);
  const [loading, setLoading] = useState(false)
  const [barrelLoading, setBarrelLoading] = useState(false)
  const { showPopup } = usePopupManager();
  const handleHrsMouseLeave = (i) => {
    const newSessionRow = {};
    Object.keys(sessionTempData[0]).forEach((key) => {
      newSessionRow[key] = sessionTempData[0][key];
    });
    const hrs = sessionTempData[i]['hrs']
    if( hrs !== "" && hrs !== "0"){
    if(isMultipleOfQuarter(parseFloat(hrs)) !== true) {
      let items = [...sessionTempData]
      let item = {...items[i], hrs: ""};
      items[i] = item
      const totalHours = myState?.totalHours;
      const bookedHrs = items.reduce((total, obj) => {
        if (obj.hrs !== "") {
          total += parseFloat(obj.hrs);
        }
        return total;
      }, 0);
      const remainingHours = totalHours - bookedHrs;
      setState((prevData) => ({
        ...prevData,
        remainingHours,
        bookedHours: bookedHrs,
      }));
      setSessionTempData(items)
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: `Please enter hours in whole numbers or increments of 0.25.`,
      });
      
    }
  }
  else if (hrs === "0"){
    let items = [...sessionTempData]
    let item = {...items[i], hrs: ""};
    items[i] = item
    setSessionTempData(items)
    showPopup({
      type: MESSAGE_TYPE.INFORMATION,
      contextText: MESSAGE_TYPE.INFORMATION,
      info: `Hours min value should be 0.25.`,
    });
  }
    setSessionData((prevData) => {
      const newData = [...prevData];
      newData.push(newSessionRow);
      return newData;
    });
  };
  // test
  const [isMobileDevice, setIsMobileDevice] = useState(window.innerWidth <= 450)
  const [deleteClicked, setDeleteClicked] = useState(false);
  const [indirectProjectsList, setIndirectProjectsList] = useState([]);
  const [projectsDropdown, setProjectsDropdown] = useState([]);
  const [projects, setProjects] = useState([]);
  const [selectionOptions, setSelectionOptions] = useState([
    {
      projectOption: [
        { value: "Projects", label: "Projects" },
        { value: "Indirect Projects", label: "Indirect Projects" },
      ],
    },
  ]);
  const [changeIndex, setChangeIndex] = useState([]);
  const [seletedDates, setSeletedDates] = useState("");
  const [operativeID, setOperativeID] = useState("");
  const [selectedDates, setSelectedDates] = useState([]);
 const handleWindowSizeChange = () => {
    setIsMobileDevice(window.innerWidth <= 450);
  }
  
  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, []);
  const location = useLocation();
  const selectedDates1 =
    location.state && location.state.selectedDates1
      ? location.state.selectedDates1
      : [];
  const [datesComingFromCalendar, setDatesComingFromCalendar] =
    useState(selectedDates1); // yyyy-mm--dd
  const [updatedKey, setUpdatedKey] = useState("");
  const [allowedToDate, setAllowedToDate] = useState("");
  const [allowedFromDate, setAllowedFromDate] = useState("");

  useEffect(() => {
    const data = {
   
    };
    setLoading(true)
    axios.post(`${baseUrl}timeBooking/checkValidDate`,data,{
      headers: {
      'Content-Type': 'application/json',
      },
      withCredentials:true
    }).then((res) => {
      dispatch(setLogin({...auth, recentStatus: res.status}))
      setLoading(false) 
      setAllowedFromDate(res.data.data[0][0]);
      setAllowedToDate(res.data.data[0][1]);
    }).catch((error) => {
      setLoading(false)
      dispatch(setLogin({...auth, recentStatus: error.response.status}))
      console.error("Error while calling API -> ", error);
    });
  }, []);

  const convertDateFormat = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // January is 0!
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };
  const isMultipleOfQuarter = (value) => {
    return Number.isInteger(value) || (value * 100) % 25 === 0;
  }
  const createNewObject = (datesArray) => {
    let newObject = {};
    datesArray.forEach((date) => {
      newObject[date] = true;
    });
    return newObject;
  };

  const [sessionTempData, setSessionTempData] = useState([
    {
      project_type: "",
      isIndirectProject: false,
      barrel: "",
      project_details: "",
      evm_activity: "",
      module_mfl: "",
      hrs: "",
    },
  ]);

  useEffect(() => {
    const changeIndexValue = changeIndex;
    if (
      changeIndex === 0 &&
      updatedKey === "project_type" &&
      seletedDates.length > 1
    ) {
      const i = changeIndex;
      setExistingData([
        {
          project_type: (
            <Select
              // className={styleSelect}
              value={
                sessionTempData[i] ? sessionTempData[i]["project_type"] : ""
              }
              options={
                selectionOptions[i] ? selectionOptions[i]["projectOption"] : ""
              }
              onChange={(selectedOption) =>
                checkDuplicates(
                  selectedOption,
                  "project_type",
                  i,
                  selectionOptions,
                  sessionTempData,
                  indirectProjectsList
                )
              }
              name="projectOption"
            />
          ),
          barrel: (
            <Select
            styles={{
              control: (provided, state) => ({
                ...provided,
                minHeight: '35px',
                height: '100%',
               
                '&:hover': {
                  borderColor: '#E9DEAE'
                },
              }),
              menuList: provided => ({
                ...provided,
                fontSize:isMobileDevice ? "10px" : "14px",
                '&::-webkit-scrollbar': {
                  width: '4px !important',
                  height: '6px',
                  display: 'block !important',
                  background: 'none',
                },
                '&::-webkit-scrollbar-track': {
                  background: 'none',
                },
                '&::-webkit-scrollbar-thumb': {
                  background: '#f17c7c',
                },
                '&::-webkit-scrollbar-thumb:hover': {
                  background: '#da6363',
                },
              }),
      
              multiValue: provided => ({
                ...provided,
                backgroundColor: '#C9AF28',
                maxWidth: '140px'
              }),
              singleValue: provided => ({
                ...provided,
                color: 'black',
                fontWeight:"400"
              }),
              multiValueLabel: provided => ({
                ...provided,
                color: '#fff'
              }),
              multiValueRemove: provided => ({
                ...provided,
                color: '#fff'
              }),
              valueContainer: provided => ({
                ...provided,
                cursor: 'text'
              }),
              menu: styles => ({ ...styles,                 
                width: isMobileDevice ? "100px" : "450px",
               })  
            }}
            
            // className={styleSelect}
              isDisabled={
                sessionTempData[i]
                  ? sessionTempData[i]["isIndirectProject"]
                  : false
              }
              value={sessionTempData[i] ? sessionTempData[i]["barrel"] : ""}
              options={
                sessionTempData[i]?.project_type?.value === "Projects"
                  ? projectsDropdown?.BarrelInfoList
                  : ""
              }
              onChange={(selectedOption) =>
                checkDuplicates(
                  selectedOption,
                  "barrel",
                  i,
                  selectionOptions,
                  sessionTempData
                )
              }
              name="barrel"
            />
          ),
          project_details: (
            <Select
            styles={{
              control: (provided, state) => ({
                ...provided,
                minHeight: '35px',
                height: '100%',
               
                '&:hover': {
                  borderColor: '#E9DEAE'
                },
              }),
              menuList: provided => ({
                ...provided,
                fontSize:isMobileDevice ? "10px" : "14px",
                '&::-webkit-scrollbar': {
                  width: '4px !important',
                  height: '6px',
                  display: 'block !important',
                  background: 'none',
                },
                '&::-webkit-scrollbar-track': {
                  background: 'none',
                },
                '&::-webkit-scrollbar-thumb': {
                  background: '#f17c7c',
                },
                '&::-webkit-scrollbar-thumb:hover': {
                  background: '#da6363',
                },
              }),
      
              multiValue: provided => ({
                ...provided,
                backgroundColor: '#C9AF28',
                maxWidth: '140px'
              }),
              singleValue: provided => ({
                ...provided,
                color: 'black',
                fontWeight:"400"
              }),
              multiValueLabel: provided => ({
                ...provided,
                color: '#fff'
              }),
              multiValueRemove: provided => ({
                ...provided,
                color: '#fff'
              }),
              valueContainer: provided => ({
                ...provided,
                cursor: 'text'
              }),
              menu: styles => ({ ...styles,                 
                width: isMobileDevice ? "100px" : "450px",
               })  
            }}
            // className={styleSelect}
              // className={clsx(styles.select, styles.sel2)}
              options={
                sessionTempData[i]?.project_type?.value === "Projects"
                  ? selectionOptions[i]?.project_details
                  : sessionTempData[i]?.project_type?.value ===
                    "Indirect Projects"
                  ? indirectProjectsList
                  : ""
              }
              value={
                sessionTempData[i] ? sessionTempData[i]["project_details"] : ""
              }
              onChange={(selectedOption) =>
                checkDuplicates(
                  selectedOption,
                  "project_details",
                  i,
                  selectionOptions,
                  sessionTempData,
                  indirectProjectsList
                )
              }
              name="projectDetails"
            />
          ),
          evm_activity: (
            <Select
              isDisabled={
                sessionTempData[i]
                  ? sessionTempData[i]["isIndirectProject"]
                  : false
              }
              styles={{
                control: (provided, state) => ({
                  ...provided,
                  minHeight: '35px',
                  height: '100%',
                 
                  '&:hover': {
                    borderColor: '#E9DEAE'
                  },
                }),
                menuList: provided => ({
                  ...provided,
                  fontSize:isMobileDevice ? "10px" : "14px",
                  '&::-webkit-scrollbar': {
                    width: '4px !important',
                    height: '6px',
                    display: 'block !important',
                    background: 'none',
                  },
                  '&::-webkit-scrollbar-track': {
                    background: 'none',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    background: '#f17c7c',
                  },
                  '&::-webkit-scrollbar-thumb:hover': {
                    background: '#da6363',
                  },
                }),
        
                multiValue: provided => ({
                  ...provided,
                  backgroundColor: '#C9AF28',
                  maxWidth: '140px'
                }),
                singleValue: provided => ({
                  ...provided,
                  color: 'black',
                  fontWeight:"400"
                }),
                multiValueLabel: provided => ({
                  ...provided,
                  color: '#fff'
                }),
                multiValueRemove: provided => ({
                  ...provided,
                  color: '#fff'
                }),
                valueContainer: provided => ({
                  ...provided,
                  cursor: 'text'
                }),
                menu: styles => ({ ...styles,                 
                  width: isMobileDevice ? "100px" : "450px",
                 })  
              }}
              // className={clsx(styles.select, styles.sel2)}
              value={
                sessionTempData[i] ? sessionTempData[i]["evm_activity"] : ""
              }
              options={
                sessionTempData[i]?.project_type?.value === "Projects"
                  ? selectionOptions[i]?.GateList
                  : ""
              }
              onChange={(selectedOption) =>
                checkDuplicates(
                  selectedOption,
                  "evm_activity",
                  i,
                  selectionOptions,
                  sessionTempData
                )
              }
              name="evmActivity"
            />
          ),
          module_mfl: (
            <Select
              isDisabled={
                sessionTempData[i]
                  ? sessionTempData[i]["isIndirectProject"]
                  : false
              }
              styles={{
                control: (provided, state) => ({
                  ...provided,
                  minHeight: '35px',
                  height: '100%',
                 
                  '&:hover': {
                    borderColor: '#E9DEAE'
                  },
                }),
                menuList: provided => ({
                  ...provided,
                  fontSize:isMobileDevice ? "10px" : "12px",
                  '&::-webkit-scrollbar': {
                    width: '4px !important',
                    height: '6px',
                    display: 'block !important',
                    background: 'none',
                  },
                  '&::-webkit-scrollbar-track': {
                    background: 'none',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    background: '#f17c7c',
                  },
                  '&::-webkit-scrollbar-thumb:hover': {
                    background: '#da6363',
                  },
                }),
        
                multiValue: provided => ({
                  ...provided,
                  backgroundColor: '#C9AF28',
                  maxWidth: '140px'
                }),
                singleValue: provided => ({
                  ...provided,
                  color: 'black',
                  fontWeight:"400"
                }),
                multiValueLabel: provided => ({
                  ...provided,
                  color: '#fff'
                }),
                multiValueRemove: provided => ({
                  ...provided,
                  color: '#fff'
                }),
                valueContainer: provided => ({
                  ...provided,
                  cursor: 'text'
                }),
                menu: styles => ({ ...styles,                 
                  width: isMobileDevice ? "100px" : "340px",
                 })  
              }}
              // className={styleSelect}
              // className={clsx(styles.select, styles.sel2)}
              value={sessionTempData[i] ? sessionTempData[i]["module_mfl"] : ""}
              options={
                sessionTempData[i]?.project_type?.value === "Projects"
                  ? projectsDropdown?.mflList
                  : ""
              }
              onChange={(selectedOption) =>
                checkDuplicates(
                  selectedOption,
                  "module_mfl",
                  i,
                  selectionOptions,
                  sessionTempData
                )
              }
              name="module"
            />
          ),
          hrs: (
            <ValidatingTextField
              variant="outlined"
              size="small"
              value={sessionTempData[i] ? sessionTempData[i]["hrs"] : ""}
              onChange={(e) =>
                handleCustomSelectChange(
                  e,
                  "hrs",
                  i,
                  selectionOptions,
                  sessionTempData
                )
              }
              name="hour"
              onBlur={()=>{handleHrsMouseLeave(i)}}
              inputProps={{
                "data-testid": "remark-input",
              }}
              style={{ width: "100%" }}
            />
          ),
        },
      ]);
    } else {
      let updatedTable = [];
      sessionTempData.map((row, i) => {
        updatedTable.push({
          project_type: (  
            <Select
              className={clsx(styles.select, styles.sel2)}
              value={
                sessionTempData[i] ? sessionTempData[i]["project_type"] : ""
              }
              options={
                selectionOptions[i] ? selectionOptions[i]["projectOption"] : ""
              }
              onChange={(selectedOption) =>
                checkDuplicates(
                  selectedOption,
                  "project_type",
                  i,
                  selectionOptions,
                  sessionTempData,
                  indirectProjectsList
                )
              }
              name="projectOption"
            />
          ),
          barrel: (
            <Select
            styles={{
              control: (provided, state) => ({
                ...provided,
                minHeight: '35px',
                height: '100%',
               
                '&:hover': {
                  borderColor: '#E9DEAE'
                },
              }),
              menuList: provided => ({
                ...provided,
                fontSize:isMobileDevice ? "10px" : "14px",
                '&::-webkit-scrollbar': {
                  width: '4px !important',
                  height: '6px',
                  display: 'block !important',
                  background: 'none',
                },
                '&::-webkit-scrollbar-track': {
                  background: 'none',
                },
                '&::-webkit-scrollbar-thumb': {
                  background: '#f17c7c',
                },
                '&::-webkit-scrollbar-thumb:hover': {
                  background: '#da6363',
                },
              }),
      
              multiValue: provided => ({
                ...provided,
                backgroundColor: '#C9AF28',
                maxWidth: '140px'
              }),
              singleValue: provided => ({
                ...provided,
                color: 'black',
                fontWeight:"400"
              }),
              multiValueLabel: provided => ({
                ...provided,
                color: '#fff'
              }),
              multiValueRemove: provided => ({
                ...provided,
                color: '#fff'
              }),
              valueContainer: provided => ({
                ...provided,
                cursor: 'text'
              }),
              menu: styles => ({ ...styles,                 
                width: isMobileDevice ? "100px" : "450px",
               })  
            }}
              isDisabled={
                sessionTempData[i]
                  ? sessionTempData[i]["isIndirectProject"]
                  : false
              }
              value={sessionTempData[i] ? sessionTempData[i]["barrel"] : ""}
              options={
                sessionTempData[i]?.project_type?.value === "Projects"
                  ? projectsDropdown?.BarrelInfoList
                  : ""
              }
              onChange={(selectedOption) =>
                checkDuplicates(
                  selectedOption,
                  "barrel",
                  i,
                  selectionOptions,
                  sessionTempData
                )
              }
              name="barrel"
            />
          ),
          project_details: (
            <Select
            styles={{
              control: (provided, state) => ({
                ...provided,
                minHeight: '35px',
                height: '100%',
               
                '&:hover': {
                  borderColor: '#E9DEAE'
                },
              }),
              menuList: provided => ({
                ...provided,
                fontSize:isMobileDevice ? "10px" : "14px",
                '&::-webkit-scrollbar': {
                  width: '4px !important',
                  height: '6px',
                  display: 'block !important',
                  background: 'none',
                },
                '&::-webkit-scrollbar-track': {
                  background: 'none',
                },
                '&::-webkit-scrollbar-thumb': {
                  background: '#f17c7c',
                },
                '&::-webkit-scrollbar-thumb:hover': {
                  background: '#da6363',
                },
              }),
      
              multiValue: provided => ({
                ...provided,
                backgroundColor: '#C9AF28',
                maxWidth: '140px'
              }),
              singleValue: provided => ({
                ...provided,
                color: 'black',
                fontWeight:"400"
              }),
              multiValueLabel: provided => ({
                ...provided,
                color: '#fff'
              }),
              multiValueRemove: provided => ({
                ...provided,
                color: '#fff'
              }),
              valueContainer: provided => ({
                ...provided,
                cursor: 'text'
              }),
              menu: styles => ({ ...styles,                 
                width: isMobileDevice ? "100px" : "450px",
               })  
            }}      
              value={
                sessionTempData[i] ? sessionTempData[i]["project_details"] : ""
              }
              options={
                sessionTempData[i]?.project_type?.value === "Projects"
                  ? selectionOptions[i]?.project_details
                  : sessionTempData[i]?.project_type?.value ===
                    "Indirect Projects"
                  ? indirectProjectsList
                  : ""
              }
              onChange={(selectedOption) =>
                checkDuplicates(
                  selectedOption,
                  "project_details",
                  i,
                  selectionOptions,
                  sessionTempData,
                  indirectProjectsList
                )
              }
              name="projectDetails"
            />
          ),
          evm_activity: (
            <Select
              isDisabled={
                sessionTempData[i]
                  ? sessionTempData[i]["isIndirectProject"]
                  : false
              }
              styles={{
                control: (provided, state) => ({
                  ...provided,
                  minHeight: '35px',
                  height: '100%',
                 
                  '&:hover': {
                    borderColor: '#E9DEAE'
                  },
                }),
                menuList: provided => ({
                  ...provided,
                  fontSize:isMobileDevice ? "10px" : "14px",
                  '&::-webkit-scrollbar': {
                    width: '4px !important',
                    height: '6px',
                    display: 'block !important',
                    background: 'none',
                  },
                  '&::-webkit-scrollbar-track': {
                    background: 'none',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    background: '#f17c7c',
                  },
                  '&::-webkit-scrollbar-thumb:hover': {
                    background: '#da6363',
                  },
                }),
        
                multiValue: provided => ({
                  ...provided,
                  backgroundColor: '#C9AF28',
                  maxWidth: '140px'
                }),
                singleValue: provided => ({
                  ...provided,
                  color: 'black',
                  fontWeight:"400"
                }),
                multiValueLabel: provided => ({
                  ...provided,
                  color: '#fff'
                }),
                multiValueRemove: provided => ({
                  ...provided,
                  color: '#fff'
                }),
                valueContainer: provided => ({
                  ...provided,
                  cursor: 'text'
                }),
                menu: styles => ({ ...styles,                 
                  width: isMobileDevice ? "100px" : "450px",
                 })  
              }}          
              value={
                sessionTempData[i] ? sessionTempData[i]["evm_activity"] : ""
              }
              options={
                sessionTempData[i]?.project_type?.value === "Projects"
                  ? selectionOptions[i]?.GateList
                  : ""
              }
              onChange={(selectedOption) =>
                checkDuplicates(
                  selectedOption,
                  "evm_activity",
                  i,
                  selectionOptions,
                  sessionTempData
                )
              }
              name="evmActivity"
            />
          ),
          module_mfl: (
            <Select
              isDisabled={
                sessionTempData[i]
                  ? sessionTempData[i]["isIndirectProject"]
                  : false
              }
              styles={{
                control: (provided, state) => ({
                  ...provided,
                  minHeight: '35px',
                  height: '100%',
                 
                  '&:hover': {
                    borderColor: '#E9DEAE'
                  },
                }),
                menuList: provided => ({
                  ...provided,
                  fontSize:isMobileDevice ? "10px" : "12px",
                  '&::-webkit-scrollbar': {
                    width: '4px !important',
                    height: '6px',
                    display: 'block !important',
                    background: 'none',
                  },
                  '&::-webkit-scrollbar-track': {
                    background: 'none',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    background: '#f17c7c',
                  },
                  '&::-webkit-scrollbar-thumb:hover': {
                    background: '#da6363',
                  },
                }),
        
                multiValue: provided => ({
                  ...provided,
                  backgroundColor: '#C9AF28',
                  maxWidth: '140px'
                }),
                singleValue: provided => ({
                  ...provided,
                  color: 'black',
                  fontWeight:"400"
                }),
                multiValueLabel: provided => ({
                  ...provided,
                  color: '#fff'
                }),
                multiValueRemove: provided => ({
                  ...provided,
                  color: '#fff'
                }),
                valueContainer: provided => ({
                  ...provided,
                  cursor: 'text'
                }),
                menu: styles => ({ ...styles,                 
                  width: isMobileDevice ? "100px" : "340px",
                 })  
              }}          
              value={sessionTempData[i] ? sessionTempData[i]["module_mfl"] : ""}
              options={
                sessionTempData[i]?.project_type?.value === "Projects"
                  ? projectsDropdown?.mflList
                  : ""
              }
              onChange={(selectedOption) =>
                checkDuplicates(
                  selectedOption,
                  "module_mfl",
                  i,
                  selectionOptions,
                  sessionTempData
                )
              }
              name="module"
            />
          ),
          hrs: (
            <ValidatingTextField
              variant="outlined"
              size="small"
              value={sessionTempData[i] ? sessionTempData[i]["hrs"] : ""}
              onChange={(e) =>
                handleCustomSelectChange(
                  e,
                  "hrs",
                  i,
                  selectionOptions,
                  sessionTempData
                )
              }
              name="hour"
              onBlur={()=>{handleHrsMouseLeave(i)}}
              inputProps={{
                "data-testid": "remark-input",
              }}
              style={{ width: "100%" }}
            />
          ),
        });
      });
      setExistingData(updatedTable);
    }
  }, [sessionTempData, indirectProjectsList, selectionOptions, deleteClicked]);

  const [existingData, setExistingData] = useState([
    {
      project_type: (
        <Select
          
          className={clsx(styles.select, styles.sel2)}
          value={sessionTempData[0] ? sessionTempData[0]["project_type"] : ""}
          options={
            selectionOptions[0] ? selectionOptions[0]["projectOption"] : ""
          }
          onChange={(selectedOption) =>
            checkDuplicates(
              selectedOption,
              "project_type",
              i,
              selectionOptions,
              sessionTempData,
              indirectProjectsList
            )
          }
          name="projectOption"
        />
      ),
      barrel: (
        <Select
        styles={{
          control: (provided, state) => ({
            ...provided,
            minHeight: '35px',
            height: '100%',
           
            '&:hover': {
              borderColor: '#E9DEAE'
            },
          }),
          menuList: provided => ({
            ...provided,
            fontSize:isMobileDevice ? "10px" : "14px",
            '&::-webkit-scrollbar': {
              width: '4px !important',
              height: '6px',
              display: 'block !important',
              background: 'none',
            },
            '&::-webkit-scrollbar-track': {
              background: 'none',
            },
            '&::-webkit-scrollbar-thumb': {
              background: '#f17c7c',
            },
            '&::-webkit-scrollbar-thumb:hover': {
              background: '#da6363',
            },
          }),
  
          multiValue: provided => ({
            ...provided,
            backgroundColor: '#C9AF28',
            maxWidth: '140px'
          }),
          singleValue: provided => ({
            ...provided,
            color: 'black',
            fontWeight:"400"
          }),
          multiValueLabel: provided => ({
            ...provided,
            color: '#fff'
          }),
          multiValueRemove: provided => ({
            ...provided,
            color: '#fff'
          }),
          valueContainer: provided => ({
            ...provided,
            cursor: 'text'
          }),
          menu: styles => ({ ...styles,                 
            width: isMobileDevice ? "100px" : "450px",
           })  
        }}
          isDisabled={
            sessionTempData[0] ? sessionTempData[0]["isIndirectProject"] : false
          }
          value={sessionTempData[0] ? sessionTempData[0]["barrel"] : ""}
          options={
            sessionTempData[0]?.project_type?.value === "Projects"
              ? projectsDropdown?.BarrelInfoList
              : ""
          }
          onChange={(selectedOption) =>
            checkDuplicates(
              selectedOption,
              "barrel",
              i,
              selectionOptions,
              sessionTempData
            )
          }
          name="barrel"
        />
      ),
      project_details: (
        <Select
        styles={{
          control: (provided, state) => ({
            ...provided,
            minHeight: '35px',
            height: '100%',
           
            '&:hover': {
              borderColor: '#E9DEAE'
            },
          }),
          menuList: provided => ({
            ...provided,
            fontSize:isMobileDevice ? "10px" : "14px",
            '&::-webkit-scrollbar': {
              width: '4px !important',
              height: '6px',
              display: 'block !important',
              background: 'none',
            },
            '&::-webkit-scrollbar-track': {
              background: 'none',
            },
            '&::-webkit-scrollbar-thumb': {
              background: '#f17c7c',
            },
            '&::-webkit-scrollbar-thumb:hover': {
              background: '#da6363',
            },
          }),
  
          multiValue: provided => ({
            ...provided,
            backgroundColor: '#C9AF28',
            maxWidth: '140px'
          }),
          singleValue: provided => ({
            ...provided,
            color: 'black',
            fontWeight:"400"
          }),
          multiValueLabel: provided => ({
            ...provided,
            color: '#fff'
          }),
          multiValueRemove: provided => ({
            ...provided,
            color: '#fff'
          }),
          valueContainer: provided => ({
            ...provided,
            cursor: 'text'
          }),
          menu: styles => ({ ...styles,                 
            width: isMobileDevice ? "100px" : "450px",
           })  
        }}
          className={clsx(styles.select, styles.sel2)}
          value={
            sessionTempData[0] ? sessionTempData[0]["project_details"] : ""
          }
          options={
            sessionTempData[0]["project_type"]?.value === "Projects"
              ? selectionOptions[0]["project_details"]
              : sessionTempData[0]["project_type"]?.value ===
                "Indirect Projects"
              ? indirectProjectsList
              : ""
          }
          onChange={(selectedOption) =>
            checkDuplicates(
              selectedOption,
              "project_details",
              i,
              selectionOptions,
              sessionTempData,
              indirectProjectsList
            )
          }
          name="projectDetails"
        />
      ),
      evm_activity: (
        <Select
        styles={{
          control: (provided, state) => ({
            ...provided,
            minHeight: '35px',
            height: '100%',
           
            '&:hover': {
              borderColor: '#E9DEAE'
            },
          }),
          menuList: provided => ({
            ...provided,
            fontSize:isMobileDevice ? "10px" : "14px",
            '&::-webkit-scrollbar': {
              width: '4px !important',
              height: '6px',
              display: 'block !important',
              background: 'none',
            },
            '&::-webkit-scrollbar-track': {
              background: 'none',
            },
            '&::-webkit-scrollbar-thumb': {
              background: '#f17c7c',
            },
            '&::-webkit-scrollbar-thumb:hover': {
              background: '#da6363',
            },
          }),
  
          multiValue: provided => ({
            ...provided,
            backgroundColor: '#C9AF28',
            maxWidth: '140px'
          }),
          singleValue: provided => ({
            ...provided,
            color: 'black',
            fontWeight:"400"
          }),
          multiValueLabel: provided => ({
            ...provided,
            color: '#fff'
          }),
          multiValueRemove: provided => ({
            ...provided,
            color: '#fff'
          }),
          valueContainer: provided => ({
            ...provided,
            cursor: 'text'
          }),
          menu: styles => ({ ...styles,                 
            width: isMobileDevice ? "100px" : "450px",
           })  
        }}
          className={clsx(styles.select, styles.sel2)}
          value={sessionTempData[0] ? sessionTempData[0]["evm_activity"] : ""}
          options={
            sessionTempData[0]?.project_type?.value === "Projects"
              ? selectionOptions[0]?.GateList
              : ""
          }
          onChange={(selectedOption) =>
            checkDuplicates(
              selectedOption,
              "evm_activity",
              i,
              selectionOptions,
              sessionTempData
            )
          }
          name="evmActivity"
        />
      ),
      module_mfl: (
        <Select
        styles={{
          control: (provided, state) => ({
            ...provided,
            minHeight: '35px',
            height: '100%',
           
            '&:hover': {
              borderColor: '#E9DEAE'
            },
          }),
          menuList: provided => ({
            ...provided,
            fontSize:isMobileDevice ? "10px" : "12px",
            '&::-webkit-scrollbar': {
              width: '4px !important',
              height: '6px',
              display: 'block !important',
              background: 'none',
            },
            '&::-webkit-scrollbar-track': {
              background: 'none',
            },
            '&::-webkit-scrollbar-thumb': {
              background: '#f17c7c',
            },
            '&::-webkit-scrollbar-thumb:hover': {
              background: '#da6363',
            },
          }),
  
          multiValue: provided => ({
            ...provided,
            backgroundColor: '#C9AF28',
            maxWidth: '140px'
          }),
          singleValue: provided => ({
            ...provided,
            color: 'black',
            fontWeight:"400"
          }),
          multiValueLabel: provided => ({
            ...provided,
            color: '#fff'
          }),
          multiValueRemove: provided => ({
            ...provided,
            color: '#fff'
          }),
          valueContainer: provided => ({
            ...provided,
            cursor: 'text'
          }),
          menu: styles => ({ ...styles,                 
            width: isMobileDevice ? "100px" : "340px",
           })  
        }}
          className={clsx(styles.select, styles.sel2)}
          value={sessionTempData[0] ? sessionTempData[0]["module_mfl"] : ""}
          options={
            sessionTempData[0]?.project_type?.value === "Projects"
              ? projectsDropdown?.mflList
              : ""
          }
          onChange={(selectedOption) =>
            checkDuplicates(
              selectedOption,
              "module_mfl",
              i,
              selectionOptions,
              sessionTempData
            )
          }
          name="module"
        />
      ),
      hrs: (
        <ValidatingTextField
          variant="outlined"
          size="small"
          value={sessionTempData[0] ? sessionTempData[0]["hrs"] : ""}
          onChange={(e) =>
            handleCustomSelectChange(
              e,
              "hrs",
              i,
              selectionOptions,
              sessionTempData
            )
          }
          name="hour"
          onBlur={()=>{handleHrsMouseLeave(i)}}
          inputProps={{
            "data-testid": "remark-input",
          }}
          style={{ width: "100%" }}
        />
      ),
    },
  ]);
  const baseUrl = useSelector((state) => state.counter.baseUrl); // useSelector
  const auth = useSelector((state) => state.auth); // useSelector
  let {
    userName,
    personNumber,
    companyCode,
    bookingStatus,
    businessArea,
    costCenter,
    personArea,
    personSubArea,
    userRole,
    sessionId,
  } = auth;
  const [plant, setPlant] = useState(null);
  const [flag, show] = useState(false);
  const [Bc, setBC] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [datesToBook, setDatesToBook] = useState([]);
  const [swapDatesColumn, setSwapDatesColumn] = useState([]);
  const [swapDates, setSwapDates] = useState([]);
  const [swapDatesTemp, setSwapDatesTemp] = useState([]);
  const [swapDatesColumnTemp, setSwapDatesColumnTemp] = useState([]);
  const [asnCount, setAsnCount] = useState(0);
  const [myState, setState] = React.useState({
    pers_no: "",
    BU: { label: "", value: "" },
    SUB_BU: "",
    PLATFORM: "",
    FAMILY: "",
    project_def: "",
    toDate: null,
    fromDate: null,
    hrs: "",
    remainingHours: "",
    bookedHours: "",
    totalHours: "",
  });
  const resetState = () => {
    setIndirectProjectsList([]);
    setProjectsDropdown([]);
    setSelectionOptions([
      {
        projectOption: [
          { value: "Projects", label: "Projects" },
          { value: "Indirect Projects", label: "Indirect Projects" },
        ],
      },
    ]);
    setSeletedDates([]);
    setChangeIndex("");
    setOperativeID("");
    setCheckedItems({});
    setBookButtonClicked(false);
    setSessionTempData([
      {
        project_type: "",
        isIndirectProject: false,
        barrel: "",
        project_details: "",
        evm_activity: "",
        module_mfl: "",
        hrs: "",
      },
    ]);
  };
  const [projectOption, setProjectOption] = useState([
    { value: "Projects", label: "Projects" },
    { value: "Indirect Projects", label: "Indirect Projects" },
  ]);
  const Projects = () => {
    const headerss = new Headers();
    headerss.append("Content-Type", "application/json");
    const apiFormatedData = {
      bc_no : costCenter,
      pers_no: sanitizeNumeric(personNumber),
      co_code: sanitizeCoCodeNumeric(companyCode),
    };
    const apiFormatedDataJson = JSON.stringify(apiFormatedData);
    setBarrelLoading(true)
    fetch(`${baseUrl}timeBooking/barrelInfoBookingIndividualDirectProject`, {
      method: "POST",
      headers: headerss,
      body: apiFormatedDataJson,
      credentials:'include'
    })
      .then((response) => {
        dispatch(setLogin({...auth, recentStatus: response.status}))
        return response.json();
        })
      .then((responseJson) => {
        setBarrelLoading(false)
        if (responseJson.data) {
          const BarrelInfoList = [];
          responseJson.data?.BarrelInfo.map((barrel) => {
            const barrelData = {
              label: barrel[1],
              value: barrel[0],
            };
            BarrelInfoList.push(barrelData);
          });
          const GateList = responseJson.data?.GateList;
          const mflList = responseJson.data?.mflList;
          setProjectsDropdown({
            BarrelInfoList: BarrelInfoList,
            GateList: GateList,
            mflList: mflList,
          });
        }
      })
      .catch((error) => {  
        setBarrelLoading(false)
        console.info(error);
      });
  };

  const getProjects = (barrel, index) => {
    setLoading(true)
    const headerss = new Headers();
    headerss.append("Content-Type", "application/json");
    if (barrel.value) {
      const apiFormatedData = {
        pers_no: sanitizeNumeric(personNumber),
        business_area: businessArea,
        barrel: barrel.value,
      };
      const apiFormatedDataJson = JSON.stringify(apiFormatedData);
      fetch(`${baseUrl}timeBooking/getOperativeProjectDetails`, {
        method: "POST",
        headers: headerss,
        body: apiFormatedDataJson,
        credentials:'include'
      })
        .then((response) => {
          setLoading(false)
        dispatch(setLogin({...auth, recentStatus: response.status}))
        return response.json();
        }
        )
        .then((responseJson) => {
          if (responseJson.data) {
            const projectList = [];
            responseJson.data?.projectList.map((project) => {
              const projectData = {
                label: project?.project,
                value: project?.project_def,
              };
              projectList.push(projectData);
            });
            let tempProjectList = [...projects];
            const tempIndex = {
              ...tempProjectList[index],
              projects: responseJson.data?.projectList,
            };
            tempProjectList[index] = tempIndex;
            setProjects(tempProjectList);
            let tempOptions = [...selectionOptions];
            const tempOption = {
              ...tempOptions[index],
              project_details: projectList,
            };
            tempOptions[index] = tempOption;
            setSelectionOptions(tempOptions);
          }
        })
        .catch((error) => {
          setLoading(false)
          console.info(error);
        });
    }
  };
  const getGateList = (project, index) => {
    setLoading(true)
    const headerss = new Headers();
    headerss.append("Content-Type", "application/json");
    if (project.value) {
      const apiFormatedData = {
        pers_no: sanitizeNumeric(personNumber),
        project_def: project.value,
      };
      const apiFormatedDataJson = JSON.stringify(apiFormatedData);
      fetch(`${baseUrl}timeBooking/getGateList`, {
        method: "POST",
        headers: headerss,
        body: apiFormatedDataJson,
        credentials:'include'
      })
        .then((response) => {
          dispatch(setLogin({...auth, recentStatus: response.status}))
          return response.json();
          })
        .then((responseJson) => {
          setLoading(false)
          if (responseJson.data) {
            const GateList = responseJson.data?.GateList;       
            let tempOptions = [...selectionOptions];
            const tempOption = { ...tempOptions[index], GateList: GateList };
            tempOptions[index] = tempOption;
            setSelectionOptions(tempOptions);
          }
        })
        .catch((error) => {
          setLoading(false)
          console.info(error);
        });
    }
  };
  const indirectProjects = () => {
    const data = {
      co_code: companyCode,
    };
    setLoading(true)
    axios
      .post(`${baseUrl}timeBooking/indirectProjectsIndividualBooking`, data,{
        headers: {
        'Content-Type': 'application/json',
        },
        withCredentials:true
      })
      .then((response) => {
        setLoading(false)
          dispatch(setLogin({...auth, recentStatus: response.status}))
          setIndirectProjectsList(response.data?.IndirectProjects);
      })
      .catch((error) => {
        setLoading(false)
        dispatch(setLogin({...auth, recentStatus: error.response.status}))
        console.error("Error while calling API -> ", error);
      });
  };

  const checkDuplicates = (
    e,
    key,
    i,
    selectionOptions,
    sessionTempData,
    dropDownList
  ) => {
    if (key !== "hrs") {
      const list = [...sessionTempData];
      const row =
        e !== null
          ? { ...list[i], [key]: { label: e?.label, value: e?.value } }
          : { ...list[i], [key]: "" };
      list[i] = row;
      const returnedList = list.map((row, i) => {
        let requiredFields = { ...row };
        if (row.project_type?.value === "Projects") {
          ["isIndirectProject", "hrs"].forEach((e) => delete requiredFields[e]);
        } else if (row.project_type?.value === "Indirect Projects") {
          [
            "barrel",
            "isIndirectProject",
            "evm_activity",
            "module_mfl",
            "hrs",
          ].forEach((e) => delete requiredFields[e]);
        } else {
          ["isIndirectProject", "hrs"].forEach((e) => delete requiredFields[e]);
        }
        return requiredFields;
      });
      const jsonObject = returnedList.map(JSON.stringify);
      const uniqueSet = new Set(jsonObject);
      const uniqueArray = Array.from(uniqueSet).map(JSON.parse);
      if (uniqueArray.length === returnedList.length) {
        if (key === "barrel") {
          getProjects(e, i);
        } else if (key === "project_details") {
          getGateList(e, i);
        }
        handleCustomSelectChange(
          e,
          key,
          i,
          selectionOptions,
          sessionTempData,
          dropDownList
        );
      } else {
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: `Same Combination selection is not allowed`,
        });
      }
    }
  };
  const validateData = () => {
    let hasMissingRequiredFields = false;
    const returnedList = sessionTempData.map((row, i) => {
      let fieldsValidate = true;
      let requiredFields = { ...row };
      if (row.project_type?.value === "Projects") {
        fieldsValidate = Object.values(requiredFields).every((value) => {
          if (value === null || value === undefined || value === "") {
            return false;
          }
          return true;
        });
        return fieldsValidate;
      } else if (row.project_type?.value === "Indirect Projects") {
        ["barrel", "isIndirectProject", "evm_activity", "module_mfl"].forEach(
          (e) => delete requiredFields[e]
        );
        fieldsValidate = Object.values(requiredFields).every((value) => {
          if (value === null || value === undefined || value === "") {
            return false;
          }
          return true;
        });
        return fieldsValidate;
      } else {
        fieldsValidate = false;
        return fieldsValidate;
      }
    });
    hasMissingRequiredFields = (returnedList) => returnedList.every(Boolean);
    hasMissingRequiredFields = returnedList.every(
      (element) => element === true
    );
    if (hasMissingRequiredFields === false) {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please fill all required fields.",
      });
      return false;
    } else {
      return true;
    }
  };

  const saveTimeBooking = () => {
    if(validateData()=== true) {
      var result = [];
      const keysDate = Object.keys(swapDates[0]).slice(1);
      const dateList = Object.values(swapDates[0]).slice(1);
      const hrsList = Object.values(swapDates[1]).slice(1);
      let tempDatesList = dateList.map((date, index) => {
        return { date: date, hrs: hrsList[index] };
      });
      let tempProjectList = sessionTempData.map((project, index) => {
        return {
          project_details: project.project_details,
          hrs: parseFloat(project.hrs),
        };
      });
      for (var j = 0; j < tempDatesList.length; j++) {
        const dailyLimit = tempDatesList[j];
        let dailyHrsLimit = parseFloat(dailyLimit.hrs);
        for (var i = 0; i < tempProjectList.length && dailyLimit.hrs > 0; i++) {
          var project = tempProjectList[i];
          let projectHrs = parseFloat(project.hrs);
          var hoursToBook = Math.min(project.hrs, dailyLimit.hrs);
          dailyLimit.hrs -= hoursToBook;
          project.hrs -= hoursToBook;
          if (hoursToBook > 0) {
            let barrel = null;
            let module_mfl = null;
            let evm_activity = null;
            let wbs_no = null;
            let network = null;
            let code_code = project.project_details?.value;
            let project_def = null;
            if (sessionTempData[i]["project_type"]?.value === "Projects") {
              code_code = null;
              project_def = project.project_details?.value;
              barrel = sessionTempData[i]["barrel"]?.value;
              module_mfl = sessionTempData[i]["module_mfl"]?.value;
              evm_activity = sessionTempData[i]["evm_activity"]?.value;
              const projectDef = project.project_details?.value;
              const projectdata = projects[i]["projects"].filter((proData) => {
                return proData?.project_def === projectDef;
              })[0];
              wbs_no = projectdata?.wbs_no;
              network = projectdata?.network;
            }
            result.push(
              {
                pers_no: sanitizeNumeric(personNumber),
                co_code: sanitizeCoCodeNumeric(companyCode),
                pers_area: personArea,
                pers_sub_area: personSubArea,
                booking_date: selectedDates[j] ? selectedDates[j].replace(/\//g, '-') : "",
                barrel_code: barrel,
                project_def: project_def,
                wbs_no: wbs_no,
                network: network,
                activity_no: evm_activity,
                mfl_id: module_mfl,
                str_user_id: sanitizeNumeric(personNumber),
                no_of_hours: hoursToBook.toString(),
                cost_center: costCenter,
                code_code: code_code,
              }
            );
          }
        }
      }
      setLoading(true)
      const apiFormatedDataJson = JSON.stringify(result);
      const headerss = new Headers();     
      headerss.append("Content-Type", "application/json");
      fetch(`${baseUrl}timeBooking/individualBookingSave`, {
        method: "POST",
        headers: headerss,
        body: apiFormatedDataJson,
        credentials:'include'
      })
        .then((response) => {
          dispatch(setLogin({...auth, recentStatus: response.status}))
          return response.json();
          })
        .then((responseJson) => {
          setLoading(false)
          if (responseJson.data[0][0] === "T") {           
            showPopup({
              type: MESSAGE_TYPE.SUCCESS,
              contextText: MESSAGE_TYPE.SUCCESS,
              info: "Time Booking saved successfully...",
            });
            if (datesComingFromCalendar.length === 0) {
              // window.location.reload();
            } else {
              history.push("/home");
            }
          }else{
            showPopup({
              type: MESSAGE_TYPE.INFORMATION,
              contextText: MESSAGE_TYPE.INFORMATION,
              info: "Booking already available for selected date",
              // reloads: true, // Set reload to true or false based on your condition
            });
          }
        })
        .catch((error) => {
          setLoading(false)
          console.info(error);
        });
    }
  };

  const handleCustomSelectChange = (
    e,
    key,
    i,
    selectionOptions,
    sessionTempData,
    dropDownList
  ) => {
    setUpdatedKey(key);
    let value = null;
    if (key === "hrs" && e.target.value === undefined) {
      value = e.target.value;
    } else if (e === null || e.value === undefined) {
      value = ""; // Extract the value based on the key
    } else {
      value = e.value;
    }
    const index = selectionOptions.length;
    let items = [...sessionTempData];
    let rowOptions = [...selectionOptions];
    if (key === "project_type" && i === 0 && existingData.length > 1) {
      let updatedData = [];
      if (i === 0) {
        let item = {};
        if (sessionTempData[i].project_type?.value !== value && value !== "") {
          if (value === "Indirect Projects") {
            item = {
              isIndirectProject: true,
              [key]: { label: e?.label, value: e?.value },
              barrel: "",
              project_details: "",
              evm_activity: "",
              module_mfl: "",
              hrs: "",
            };
            const rowOption = {
              ...rowOptions[i],
              projectDetails: dropDownList,
            };
            rowOptions[i] = rowOption;
            setSelectionOptions(rowOptions);
          } else if (value === "Projects") {
            item = {
              isIndirectProject: false,
              [key]: { label: e?.label, value: e?.value },
              barrel: "",
              project_details: "",
              evm_activity: "",
              module_mfl: "",
              hrs: "",
            };
          }
          updatedData.push(item);
          setSessionTempData(updatedData);
        } else if (value === undefined || value === null || value === "") {
          item = {
            isIndirectProject: false,
            [key]: "",
            barrel: "",
            project_details: "",
            evm_activity: "",
            module_mfl: "",
            hrs: "",
          };
          updatedData.push(item);
          setSessionTempData(updatedData);
        }
      }
    } else {
      let item = { ...items[i] };
      if (key === "project_type" && value === "Indirect Projects") {
        if (value === "") {
          item = {
            isIndirectProject: true,
            [key]: "",
            barrel: "",
            project_details: "",
            evm_activity: "",
            module_mfl: "",
            hrs: "",
          };
        } else {
          item = {
            ...items[i],
            isIndirectProject: true,
            [key]: { label: e?.label, value: e?.value },
            barrel: "",
            project_details: "",
            evm_activity: "",
            module_mfl: "",
            hrs: "",
          };
          const rowOption = {
            ...rowOptions[i],
            projectDetails: [...dropDownList],
          };
          rowOptions[i] = rowOption;
          setSelectionOptions(rowOptions);
        }
      } else if (key === "project_type") {
        if (value === "") {
          item = {
            isIndirectProject: false,
            [key]: "",
            barrel: "",
            project_details: "",
            evm_activity: "",
            module_mfl: "",
            hrs: "",
          };
        } else {
          item = {
            ...items[i],
            isIndirectProject: false,
            [key]: { label: e?.label, value: e?.value },
            barrel: "",
            project_details: "",
            evm_activity: "",
            module_mfl: "",
            hrs: "",
          };
        }
      } else if (key === "hrs") { 
        const regex = /^(\d+(\.\d{0,2})?|\.\d{1,2})?$/;
        if (
          e.target.value != undefined ||
          e.target.value !== "" ||
          e.target.value !== null
        ) {
          if (regex.test(e.target.value) || e.target.value === '.'|| e.target.value === ''){           
            const hour = parseFloat(e.target.value);

          let remainingHours = myState.remainingHours;
          let totalHours = myState.totalHours;
          let bookedHrs = myState?.bookedHours ? myState?.bookedHours : 0;
          if (hour === "") {
            let tempData = [...items];
            const tempRow = { ...tempData[i], [key]: e.target.value };
            tempData[i] = tempRow;       
            bookedHrs = tempData.reduce((total, obj) => {
              if (obj.hrs !== "") {
                total += parseFloat(obj.hrs);
              }
              return total;
            }, 0);
            remainingHours = totalHours - bookedHrs;
            setState((prevData) => ({
              ...prevData,
              remainingHours,
              bookedHours: bookedHrs,
            }));
            item = { ...items[i], [key]: e.target.value };
          } else if (hour < 0) {
            showPopup({
              type: MESSAGE_TYPE.INFORMATION,
              contextText: MESSAGE_TYPE.INFORMATION,
              info: "Booking Hours should not be negative or 0",
            });
          } else if (hour > 0) {
            let tempData = [...items];
            const tempRow = { ...tempData[i], [key]: e.target.value };
            tempData[i] = tempRow;
            bookedHrs = tempData.reduce((total, obj) => {
              if (obj.hrs !== "") {
                total += parseFloat(obj.hrs);
              }
              return total;
            }, 0);
            remainingHours = totalHours - bookedHrs;
            if (bookedHrs <= totalHours && remainingHours >= 0) {
              setState((prevData) => ({
                ...prevData,
                remainingHours,
                bookedHours: bookedHrs,
              }));
              item = { ...items[i], [key]: e.target.value };
            } else if (bookedHrs > totalHours) {
              showPopup({
                type: MESSAGE_TYPE.INFORMATION,
                contextText: MESSAGE_TYPE.INFORMATION,
                info: "Over booking is not allowed",
              });
            }
          } else if (bookedHrs > totalHours) {
            showPopup({
              type: MESSAGE_TYPE.INFORMATION,
              contextText: MESSAGE_TYPE.INFORMATION,
              info: "Over booking is not allowed",
            });
          }else{
            item = { ...items[i], [key]: e.target.value};
          }
        }
        } else {
          item = { ...items[i], [key]: "" };
        }
      } else if (key === "barrel") {
        if (value === "") {
          item = {
            ...items[i],
            [key]: "",
            project_details: "",
            evm_activity: "",
            module_mfl: "",
            hrs: "",
          };
        } else if (items[i].barrel?.value !== value) {
          item = {
            ...items[i],
            [key]: { label: e?.label, value: e?.value },
            project_details: "",
            evm_activity: "",
            module_mfl: "",
            hrs: "",
          };
        }
      } else if (key === "project_details") {
        if (value === "") {
          item = {
            ...items[i],
            [key]: "",
            evm_activity: "",
            module_mfl: "",
            hrs: "",
          };
        } else if (items[i].project_details?.value !== value) {
          item = {
            ...items[i],
            [key]: { label: e?.label, value: e?.value },
            evm_activity: "",
            module_mfl: "",
            hrs: "",
          };
        }
      } else if (value === "") {
        item = { ...items[i], isIndirectProject: false, [key]: "" };
      } else {
        item = { ...items[i], [key]: { label: e?.label, value: e?.value } };
      }
      items[i] = item;
      let tempData = [...items];
      const totalHours = myState?.totalHours;
      const bookedHrs = tempData.reduce((total, obj) => {
        if (obj.hrs !== "") {
          total += parseFloat(obj.hrs);
        }
        return total;
      }, 0);
      const remainingHours = totalHours - bookedHrs;
      setState((prevData) => ({
        ...prevData,
        remainingHours,
        bookedHours: bookedHrs,
      }));
      setSessionTempData(items);
    }
    setChangeIndex(i);
  };
  

  const handleDelete = (index) => {
    setDeleteClicked(!deleteClicked);
    const totalHours = myState?.totalHours;
    if (sessionTempData.length > 1) {
      existingData.splice(index, 1);
      setExistingData(existingData);
      sessionTempData.splice(index, 1);
      const bookedHrs = sessionTempData.reduce((total, obj) => {
        if (obj.hrs !== "") {
          total += parseFloat(obj.hrs);
        }
        return total;
      }, 0);
      const remainingHours = totalHours - bookedHrs;
      setState((prevData) => ({
        ...prevData,
        remainingHours,
        bookedHours: bookedHrs,
      }));
      setSessionTempData(sessionTempData);
    } else if (sessionTempData.length === 1 && index === 0) {
      setSessionTempData([
        {
          project_type: "",
          isIndirectProject: false,
          barrel: "",
          project_details: "",
          evm_activity: "",
          module_mfl: "",
          hrs: "",
        },
      ]);
      setState((prevData) => ({
        ...prevData,
        remainingHours: totalHours,
        bookedHours: 0,
      }));
    }
  };

  const convert2 = (str) => {
    if (str == null) {
      return "";
    } else {
      let date = str;
      if (typeof str === "string") {
        date = new Date(str);
      }
      const mnth = `0${date.getMonth() + 1}`.slice(-2);
      const day = `0${date.getDate()}`.slice(-2);

      return [date.getFullYear(), mnth, day].join("-"); // 03/08/2022
    }
  };
  const convertViewDate = (str) => {
    if (!str) {
      return "";
    }
    const m = moment(str, moment.ISO_8601, true);
    if (!m.isValid()) {
      const date = new Date(str);
      if (isNaN(date)) return "";
      const mnth = `0${date.getMonth() + 1}`.slice(-2);
      const day = `0${date.getDate()}`.slice(-2);
      return [day, mnth, date.getFullYear()].join("-");
    }
    return m.format("DD-MM-YYYY");
  };
  

const convertBookingDate = (str) => {
  if (!str) {
    return "";
  }
  const m = moment(str, moment.ISO_8601, true);
  if (!m.isValid()) {
    const date = new Date(str);
    if (isNaN(date)) return "";
    const mnth = `0${date.getMonth() + 1}`.slice(-2);
    const day = `0${date.getDate()}`.slice(-2);
    return [day, mnth, date.getFullYear()].join("/");
  }
  return m.format("YYYY/MM/DD");
};

  const getDatesToBook = () => {
    const apiFormatedData = {
      pers_no: sanitizeNumeric(personNumber),
      co_code: sanitizeCoCodeNumeric(companyCode),
    };
    setLoading(true)
    const apiFormatedDataJson = JSON.stringify(apiFormatedData);
    const headerss = new Headers();
    headerss.append("Content-Type", "application/json");
    fetch(`${baseUrl}timeBooking/viewDatesToBook`, {
      method: "POST",
      headers: headerss,
      body: apiFormatedDataJson,
      credentials:'include'
    })
      .then((response) => {
        dispatch(setLogin({...auth, recentStatus: response.status}))
        return response.json();
        })
      .then((responseJson) => {
        if (responseJson.data) {
          // setLoading(false)
          if (responseJson.data.length === 0) {
            showPopup({
              type: MESSAGE_TYPE.INFORMATION,
              contextText: MESSAGE_TYPE.INFORMATION,
              info: "Your booking is up-to-date.",
              // reloads: true, // Set reload to true or false based on your condition
            });
            history.push("/home");
          } else {
            const finalData = [];
            responseJson.data.map((item) => {
              const data = {
                selection: (
                  <input
                    type="checkbox"
                    onChange={(e) => handleCheckboxChange(e, item[0])}
                  />
                ),
                date: item[0],
                day: item[1],
              };
              finalData.push(data);
            });
            setDatesToBook(finalData);
          }
        }
      })
      .catch((error) => {
        setLoading(false)
        console.info(error);
      });
  };

  useEffect(() => {
    getDatesToBook();
  }, []);

  const validDate = (dateStr) => {
    const [day, month, year] = dateStr.split("-");
    return new Date(year, month - 1, day);
  };

  

  function mapResponse(swapData, response) {
    const days = response.map((item) =>
      moment(item.date).format("ddd").toUpperCase()
    );
    const hours = response.map((item) =>
      item.hrs === -1 ? "Booking Done" : item.hrs
    );

    return swapData.map((item, index) => {
      if (item.date === "Day") {
        return days.reduce((acc, day, i) => ({ ...acc, [`day+${i}`]: day }), {
          date: item.date,
        });
      } else if (item.date === "Hours") {
        return hours.reduce(
          (acc, hour, i) => ({ ...acc, [`hrs+${i}`]: hour }),
          { date: item.date }
        );
      }
      return item;
    });
  }

  const getSwapDetailsCalendar = () => {
    setLoading(true)
    const convertedDates = datesComingFromCalendar.map((date) =>
      convertDateFormat(date)
    );
    const datesObject = createNewObject(convertedDates);
    setCheckedItems(datesObject); // dd-mm-yyyy
    const finalData = [];
    const d = {
      pers_no: sanitizeNumeric(personNumber),
      co_code: sanitizeCoCodeNumeric(companyCode),
    };
    const dj = JSON.stringify(d);
    const headersss = new Headers(); 
    headersss.append("Content-Type", "application/json");
    fetch(`${baseUrl}timeBooking/viewDatesToBook`, {
      method: "POST",
      headers: headersss,
      body: dj,
      credentials:'include'
    })
      .then((response) => {
        dispatch(setLogin({...auth, recentStatus: response.status}))
        return response.json();
        })
      .then((responseJson) => {
        setLoading(false)
        if (responseJson.data) {
          if (responseJson.data.length === 0) {
            
            showPopup({
              type: MESSAGE_TYPE.INFORMATION,
              contextText: MESSAGE_TYPE.INFORMATION,
              info: "Your booking is up-to-date.",
            });
            history.push("/home");
          } else {
            responseJson.data.map((item) => {
              const data = {
                selection: (
                  <input
                    type="checkbox"
                    onChange={(e) => handleCheckboxChange(e, item[0])}
                  />
                ),
                date: item[0],
                day: item[1],
              };
              finalData.push(data);
            });
          }
        }
      })
      .catch((error) => {
        console.info(error);
      });

    let apiFormatedData1 = {};
    let fromDate = "";
    let toDate = "";
    if (datesComingFromCalendar.length === 1) {
      fromDate = datesComingFromCalendar[0];
      toDate = datesComingFromCalendar[0];
      apiFormatedData1 = {
        pers_no: sanitizeNumeric(personNumber),
        co_code: sanitizeCoCodeNumeric(companyCode),
        from_date: fromDate,
        to_date: toDate,
      };
    } else if (datesComingFromCalendar.length > 1) {
      const validDates = datesComingFromCalendar
        .map((date) => moment(date))
        .filter((momentObj) => momentObj.isValid());

      if (validDates.length > 1) {
        const minDate = moment.min(validDates);
        const maxDate = moment.max(validDates);

        fromDate = minDate.format("YYYY-MM-DD");
        toDate = maxDate.format("YYYY-MM-DD");
        apiFormatedData1 = {
          pers_no: sanitizeNumeric(personNumber),
          co_code: sanitizeCoCodeNumeric(companyCode),
          from_date: fromDate,
          to_date: toDate,
        };
      }
    
    }
    const apiFormatedDataJson = JSON.stringify(apiFormatedData1);
    setLoading(true)
    const headerss = new Headers();
    headerss.append("Content-Type", "application/json"); 
    fetch(`${baseUrl}timeBooking/batchBookingIndividual`, {
      method: "POST",
      headers: headerss,
      body: apiFormatedDataJson,
      credentials:'include'
    })
      .then((response) => {
        dispatch(setLogin({...auth, recentStatus: response.status}))
        return response.json();
        })
      .then((responseJson) => {
        if (responseJson.msg === "Booking is already done within this range") {
          history.push("/home");
          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: "Booking is already done within this range",
          });
        } else {
          const checkedDates = Object.keys(checkedItems);
          const checked = datesComingFromCalendar;        
          const DateCovert = datesComingFromCalendar;     
          const findMany = responseJson.individualHrs.filter((x) => x.hrs > 0);
          setSeletedDates(findMany);
          const h = findMany.reduce((total, item) => total + item.hrs, 0);
          setState((prevData) => ({
            ...prevData,
            totalHours: h,
            remainingHours: h,
          }));   
          const columns = findMany.map(({ date }) => convertViewDate(date));         
          const columns1 = responseJson.individualHrs.map(({ date }) =>
            convertViewDate(date)
          );
          const bookFormatDates = findMany.map(({ date }) =>
            convertBookingDate(date)
          );
          setSelectedDates(bookFormatDates);
          const compareDates = [...columns];
          const compareDates1 = [...columns1];
          columns.splice(0, 0, "Attendance Date");
          columns1.splice(0, 0, "Attendance Date_120");
          setSwapDatesColumn(columns);
          setSwapDatesColumnTemp(columns1);
          const swapData = [{ date: "Day" }, { date: "Hours" }];
          const swapData1 = [{ date: "Day" }, { date: "Hours" }];   
          findMany.map((data, index) => {
            swapData[0][`day+${index}`] = finalData.filter((row) => {
              return row.date === compareDates[index];
            })[0]?.day;
            swapData[1][`hrs+${index}`] = data.hrs;
          });       
          const result = mapResponse(swapData1, responseJson.individualHrs);
          setSwapDates(swapData);
          setSwapDatesTemp(result);
          const totalHours = myState?.totalHours;
          setState((prevData) => ({
            ...prevData,
            remainingHours: totalHours,
            bookedHours: 0,
          }));
          setSessionTempData([
            {
              project_type: "",
              isIndirectProject: false,
              barrel: "",
              project_details: "",
              evm_activity: "",
              module_mfl: "",
              hrs: "",
            },
          ]);
          setBookButtonClicked(true);
          setLoading(false)
        }
      })
      .catch((error) => {
        setLoading(false)
        console.info(error);
      });
  };

  const [datesLoaded, setDatesLoaded] = useState(false);

  useEffect(() => {
    if (datesComingFromCalendar.length !== 0) {
      getSwapDetailsCalendar();
    }
  }, []);

  if (fromDate && toDate) {
    const fromDateMoment = moment(fromDate);
    const toDateMoment = moment(toDate);

    const diffInDays = toDateMoment.diff(fromDateMoment, "days") + 1;
  }

  const getSwapDetails = () => {
    if (fromDate != null && toDate != null) {
      const fromDateMoment1 = moment(fromDate);
      const toDateMoment1 = moment(toDate);
      const diffInDays = toDateMoment1.diff(fromDateMoment1, "days") + 1;
      if (
        moment(fromDate).isBetween(allowedFromDate, allowedToDate, 'day', '[ ]') &&
        moment(toDate).isBetween(allowedFromDate, allowedToDate, 'day', '[ ]')
      ) {
        if (diffInDays > 10) {
          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: `You can choose a period of a maximum of 10 days in a batch`,
          });
        }else if (moment(toDate).isSameOrAfter(fromDate)) {
          let fromDate_format = fromDate.format('YYYY-MM-DD');
          let toDate_format = toDate.format('YYYY-MM-DD');
            const apiFormatedData = {
              pers_no: sanitizeNumeric(personNumber),
              co_code: sanitizeCoCodeNumeric(companyCode),
              from_date: fromDate_format,
              to_date: toDate_format,
            };
            const apiFormatedDataJson = JSON.stringify(apiFormatedData);
            setLoading(true)         
            const headerss = new Headers();       
            headerss.append("Content-Type", "application/json");
            fetch(`${baseUrl}timeBooking/batchBookingIndividual`, {
              method: "POST",
              headers: headerss,
              body: apiFormatedDataJson,
              credentials:'include'
            })
              .then((response) => {
                dispatch(setLogin({...auth, recentStatus: response.status}))
                return response.json();
                })
              .then((responseJson) => {
                setLoading(false)
                if (responseJson.totalHrs === "  -1.00") {
                  showPopup({
                    type: MESSAGE_TYPE.INFORMATION,
                    contextText: MESSAGE_TYPE.INFORMATION,
                    info: `Booking for selected Dates already booked`,
                  });
                } else if (responseJson.individualHrs) {
                  const checkedDates = Object.keys(checkedItems);
                  const checked = Object.keys(checkedItems).filter((key) => {
                    return checkedItems[key] === true;
                  });
                  const DateCovert = checked.map(() =>
                    convert2(new Date(validDate(element)))
                  );
                  const findMany = responseJson.individualHrs.filter(
                    (x) => x.hrs > 0
                  );
                  setSeletedDates(findMany);
                  const h = findMany.reduce(
                    (total, item) => total + item.hrs,
                    0
                  );
                  setState((prevData) => ({
                    ...prevData,
                    totalHours: h,
                    remainingHours: h,
                  }));
                  const columns = findMany.map(({ date }) =>
                    convertViewDate(date)
                  );
                  const columns1 = responseJson.individualHrs.map(({ date }) =>
                    convertViewDate(date)
                  );
                  const bookFormatDates = findMany.map(({ date }) =>
                    convertBookingDate(date)
                  );
                  setSelectedDates(bookFormatDates);
                  const compareDates = [...columns];
                  const compareDates1 = [...columns1];
                  columns.splice(0, 0, "Attendance Date");
                  columns1.splice(0, 0, "Attendance Date");
                  setSwapDatesColumn(columns);
                  setSwapDatesColumnTemp(columns1);
                  const swapData = [{ date: "Day" }, { date: "Hours" }];
                  const swapData1 = [{ date: "Day" }, { date: "Hours" }];
                  findMany.map((data, index) => {
                    swapData[0][`day+${index}`] = datesToBook.filter((row) => {
                      return row.date === compareDates[index];
                    })[0]?.day;
                    swapData[1][`hrs+${index}`] = data.hrs;
                  });
                  const result = mapResponse(
                    swapData1,
                    responseJson.individualHrs
                  );               
                  setSwapDates(swapData);
                  setSwapDatesTemp(result);
                  const totalHours = myState?.totalHours;
                  setState((prevData) => ({
                    ...prevData,
                    remainingHours: totalHours,
                    bookedHours: 0,
                  }));
                  setSessionTempData([
                    {
                      project_type: "",
                      isIndirectProject: false,
                      barrel: "",
                      project_details: "",
                      evm_activity: "",
                      module_mfl: "",
                      hrs: "",
                    },
                  ]);
                  setBookButtonClicked(true);
                } else {
                  showPopup({
                    type: MESSAGE_TYPE.INFORMATION,
                    contextText: MESSAGE_TYPE.INFORMATION,
                    info: responseJson?.msg,
                  });
                  setBookButtonClicked(false);
                  setSwapDates([]);
                  setSwapDatesColumn([]);
                  const totalHours = myState?.totalHours;
                  setState((prevData) => ({
                    ...prevData,
                    remainingHours: totalHours,
                    bookedHours: 0,
                  }));
                  setSessionTempData([
                    {
                      project_type: "",
                      isIndirectProject: false,
                      barrel: "",
                      project_details: "",
                      evm_activity: "",
                      module_mfl: "",
                      hrs: "",
                    },
                  ]);
                }
              })
              .catch((error) => {
                setLoading(false)
                console.info(error);
              });
          } else {
            showPopup({
              type: MESSAGE_TYPE.INFORMATION,
              contextText: MESSAGE_TYPE.INFORMATION,
              info: `From date cannot be greater than to date`,
            });
          }
      } else if (toDateMoment1.isAfter(moment(), 'day')) {
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: `Booking can only be done till current date`,
        });
      } else {
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: `Please note that Time Booking for a particular month can be done as:
            (1st - 25th): Month End
            (26th - Month End): 5th day of next month.
            For Example:
            1st-25th April: 30th April
            26th-30th April: 5th May`,
        });
      }
    } else {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: `Please select all required fields`,
      });
    }
  };

  useEffect(() => {
    indirectProjects();
    Projects();
  }, []);

  const [bookButtonClicked, setBookButtonClicked] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);

  const redirectToApplicationLandingPage = () => {
    history.push("/home");
  };

  const [deletedData, setDeletedData] = useState([]);

  const addRow = (i) => {
    if (validateData() === true) {
      const index = selectionOptions.length;
      let items = [...selectionOptions];
      let Projectdropdown = [];
      let item = { ...items[i], projectOption: projectOption };
      items[i] = item;
      setSelectionOptions(items);
      setChangeIndex(i);
      const newRow = {
        project_type: (
          <Select          
          styles={{
            control: (provided, state) => ({
              ...provided,
              minHeight: '35px',
              height: '100%',
             
              '&:hover': {
                borderColor: '#E9DEAE'
              },
            }),
            menuList: provided => ({
              ...provided,
              fontSize:isMobileDevice ? "10px" : "14px",
              '&::-webkit-scrollbar': {
                width: '4px !important',
                height: '6px',
                display: 'block !important',
                background: 'none',
              },
              '&::-webkit-scrollbar-track': {
                background: 'none',
              },
              '&::-webkit-scrollbar-thumb': {
                background: '#f17c7c',
              },
              '&::-webkit-scrollbar-thumb:hover': {
                background: '#da6363',
              },
            }),
    
            multiValue: provided => ({
              ...provided,
              backgroundColor: '#C9AF28',
              maxWidth: '140px'
            }),
            singleValue: provided => ({
              ...provided,
              color: 'black',
              fontWeight:"400"
            }),
            multiValueLabel: provided => ({
              ...provided,
              color: '#fff'
            }),
            multiValueRemove: provided => ({
              ...provided,
              color: '#fff'
            }),
            valueContainer: provided => ({
              ...provided,
              cursor: 'text'
            }),
            menu: styles => ({ ...styles,                 
              width: isMobileDevice ? "100px" : "250px",
             })  
            }} 
            className={clsx(styles.select, styles.sel2)}
            value={sessionTempData[i] ? sessionTempData[i].project_type : ""}
            options={i === 0 ? projectOption : Projectdropdown}
            onChange={(selectedOption) =>
              checkDuplicates(
                selectedOption,
                "project_type",
                i,
                selectionOptions,
                sessionTempData,
                indirectProjects
              )
            }
            name="projectOption"
          />
        ),
        barrel: (
          <Select         
          styles={{
            control: (provided, state) => ({
              ...provided,
              minHeight: '35px',
              height: '100%',
             
              '&:hover': {
                borderColor: '#E9DEAE'
              },
            }),
            menuList: provided => ({
              ...provided,
              fontSize:isMobileDevice ? "10px" : "14px",
              '&::-webkit-scrollbar': {
                width: '4px !important',
                height: '6px',
                display: 'block !important',
                background: 'none',
              },
              '&::-webkit-scrollbar-track': {
                background: 'none',
              },
              '&::-webkit-scrollbar-thumb': {
                background: '#f17c7c',
              },
              '&::-webkit-scrollbar-thumb:hover': {
                background: '#da6363',
              },
            }),
    
            multiValue: provided => ({
              ...provided,
              backgroundColor: '#C9AF28',
              maxWidth: '140px'
            }),
            singleValue: provided => ({
              ...provided,
              color: 'black',
              fontWeight:"400"
            }),
            multiValueLabel: provided => ({
              ...provided,
              color: '#fff'
            }),
            multiValueRemove: provided => ({
              ...provided,
              color: '#fff'
            }),
            valueContainer: provided => ({
              ...provided,
              cursor: 'text'
            }),
            menu: styles => ({ ...styles,                 
              width: isMobileDevice ? "100px" : "450px",
             })  
          }}
            isDisabled={
              sessionTempData[i]
                ? sessionTempData[i]["isIndirectProject"]
                : false
            }
            value={sessionTempData[i] ? sessionTempData[i]["barrel"] : ""}
            options={
              sessionTempData[i]?.project_type?.value === "Projects"
                ? projectsDropdown?.BarrelInfoList
                : ""
            }
            onChange={(selectedOption) =>
              checkDuplicates(
                selectedOption,
                "barrel",
                i,
                selectionOptions,
                sessionTempData
              )
            }
            name="barrel"
          />
        ),
        project_details: (
          <Select
          styles={{
            control: (provided, state) => ({
              ...provided,
              minHeight: '35px',
              height: '100%',
             
              '&:hover': {
                borderColor: '#E9DEAE'
              },
            }),
            menuList: provided => ({
              ...provided,
              fontSize:isMobileDevice ? "10px" : "14px",
              '&::-webkit-scrollbar': {
                width: '4px !important',
                height: '6px',
                display: 'block !important',
                background: 'none',
              },
              '&::-webkit-scrollbar-track': {
                background: 'none',
              },
              '&::-webkit-scrollbar-thumb': {
                background: '#f17c7c',
              },
              '&::-webkit-scrollbar-thumb:hover': {
                background: '#da6363',
              },
            }),
    
            multiValue: provided => ({
              ...provided,
              backgroundColor: '#C9AF28',
              maxWidth: '140px'
            }),
            singleValue: provided => ({
              ...provided,
              color: 'black',
              fontWeight:"400"
            }),
            multiValueLabel: provided => ({
              ...provided,
              color: '#fff'
            }),
            multiValueRemove: provided => ({
              ...provided,
              color: '#fff'
            }),
            valueContainer: provided => ({
              ...provided,
              cursor: 'text'
            }),
            menu: styles => ({ ...styles,                 
              width: isMobileDevice ? "100px" : "450px",
             })  
          }}          
            value={
              sessionTempData[i] ? sessionTempData[i]["project_details"] : ""
            }
            options={
              sessionTempData[i]?.project_type?.value === "Projects"
                ? selectionOptions[i]?.project_details
                : sessionTempData[i]?.project_type?.value ===
                  "Indirect Projects"
                ? indirectProjectsList
                : ""
            }
            onChange={(selectedOption) =>
              checkDuplicates(
                selectedOption,
                "project_details",
                i,
                selectionOptions,
                sessionTempData,
                indirectProjectsList
              )
            }
            name="projectDetails"
          />
        ),
        evm_activity: (
          <Select
            isDisabled={
              sessionTempData[i]
                ? sessionTempData[i]["isIndirectProject"]
                : false
            }
            styles={{
              control: (provided, state) => ({
                ...provided,
                minHeight: '35px',
                height: '100%',
               
                '&:hover': {
                  borderColor: '#E9DEAE'
                },
              }),
              menuList: provided => ({
                ...provided,
                fontSize:isMobileDevice ? "10px" : "14px",
                '&::-webkit-scrollbar': {
                  width: '4px !important',
                  height: '6px',
                  display: 'block !important',
                  background: 'none',
                },
                '&::-webkit-scrollbar-track': {
                  background: 'none',
                },
                '&::-webkit-scrollbar-thumb': {
                  background: '#f17c7c',
                },
                '&::-webkit-scrollbar-thumb:hover': {
                  background: '#da6363',
                },
              }),
      
              multiValue: provided => ({
                ...provided,
                backgroundColor: '#C9AF28',
                maxWidth: '140px'
              }),
              singleValue: provided => ({
                ...provided,
                color: 'black',
                fontWeight:"400"
              }),
              multiValueLabel: provided => ({
                ...provided,
                color: '#fff'
              }),
              multiValueRemove: provided => ({
                ...provided,
                color: '#fff'
              }),
              valueContainer: provided => ({
                ...provided,
                cursor: 'text'
              }),
              menu: styles => ({ ...styles,                 
                width: isMobileDevice ? "100px" : "450px",
               })  
            }}      
            value={sessionTempData[i] ? sessionTempData[i]["evm_activity"] : ""}
            options={
              sessionTempData[i]?.project_type?.value === "Projects"
                ? selectionOptions[i]?.GateList
                : ""
            }
            onChange={(selectedOption) =>
              checkDuplicates(
                selectedOption,
                "evm_activity",
                i,
                selectionOptions,
                sessionTempData
              )
            }
            name="evmActivity"
          />
        ),
        module_mfl: (
          <Select
            isDisabled={
              sessionTempData[i]
                ? sessionTempData[i]["isIndirectProject"]
                : false
            }
            styles={{
              control: (provided, state) => ({
                ...provided,
                minHeight: '35px',
                height: '100%',
               
                '&:hover': {
                  borderColor: '#E9DEAE'
                },
              }),
              menuList: provided => ({
                ...provided,
                fontSize:isMobileDevice ? "10px" : "12px",
                '&::-webkit-scrollbar': {
                  width: '4px !important',
                  height: '6px',
                  display: 'block !important',
                  background: 'none',
                },
                '&::-webkit-scrollbar-track': {
                  background: 'none',
                },
                '&::-webkit-scrollbar-thumb': {
                  background: '#f17c7c',
                },
                '&::-webkit-scrollbar-thumb:hover': {
                  background: '#da6363',
                },
              }),
      
              multiValue: provided => ({
                ...provided,
                backgroundColor: '#C9AF28',
                maxWidth: '140px'
              }),
              singleValue: provided => ({
                ...provided,
                color: 'black',
                fontWeight:"400"
              }),
              multiValueLabel: provided => ({
                ...provided,
                color: '#fff'
              }),
              multiValueRemove: provided => ({
                ...provided,
                color: '#fff'
              }),
              valueContainer: provided => ({
                ...provided,
                cursor: 'text'
              }),
              menu: styles => ({ ...styles,                 
                width: isMobileDevice ? "100px" : "340px",
               })  
            }}       
            value={sessionTempData[i] ? sessionTempData[i]["module_mfl"] : ""}
            options={
              sessionTempData[i]?.project_type?.value === "Projects"
                ? projectsDropdown?.mflList
                : ""
            }
            onChange={(selectedOption) =>
              checkDuplicates(
                selectedOption,
                "module_mfl",
                i,
                selectionOptions,
                sessionTempData
              )
            }
            name="module"
          />
        ),
        hrs: (
          <ValidatingTextField
            variant="outlined"
            size="small"
            value={sessionTempData[i] ? sessionTempData[i]["hrs"] : ""}
            onChange={(e) =>
              handleCustomSelectChange(
                e,
                "hrs",
                i,
                selectionOptions,
                sessionTempData
              )
            }
            name="hour"
            onBlur={()=>{handleHrsMouseLeave(i)}}
            inputProps={{
              "data-testid": "remark-input",
            }}
            style={{ width: "100%" }}
          />
        ),
      };
      setExistingData([...existingData, newRow]);
      const newEmptyRow = {
        project_type: "",
        isIndirectProject: false,
        barrel: "",
        project_details: "",
        evm_activity: "",
        module_mfl: "",
        hrs: "",
      };
      setSessionTempData([...sessionTempData, newEmptyRow]);
    }
  };

  const doneAdding = () => {
    const newRow = {};
    Object.keys(data[0]).forEach((key) => {
      newRow[key] = data[0][key];
    });
    setSessionData([...sessionData, newRow]);
  };


  const [checkedItems, setCheckedItems] = useState({});
  const handleCheckboxChange = (event, index) => {
    const date = moment(index).format("DD-MM-YYYY");
    const { checked } = event.target;
    setCheckedItems((prevState) => ({
      ...prevState,
      [index]: checked,
    }));
  };

  useEffect(() => {
    const extractedData = Object.entries(checkedItems)
      .filter(([_, checked]) => checked)
      .map(([index, _]) => parseInt(index))
      .filter((index) => index < existingData.length)
      .map((index) => existingData[index].project_details);

    setDeletedData(extractedData);
  }, [checkedItems]);


  useEffect(() => {
    setBookButtonClicked(false)
  }, [fromDate, toDate])

  const handleOnclickDate = (date) => {
    const dateVal = date;
      setFromDate(dateVal);
      setToDate(dateVal);
  }

const handleExtraCheckDuplicateBooking = async() =>{
  try {
    const payload = {
      'pers_no' : sanitizeNumeric(personNumber),
      'dates' :sanitizeCoCodeNumeric(selectedDates)
    }
    const response = await apiService.CheckBookingDates(payload,dispatch)
    if(response?.data?.msg === 'Fail'){
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: response.data.message,
      })
      history.push('/home')
      
    }
  } catch (error) {
    console.error(error)
  }
}

useEffect(()=>{
if(myState.remainingHours === 0){
  handleExtraCheckDuplicateBooking()
}
},[myState.remainingHours])

  const renderDatesToBook = () => (
    <div className={styles.formGroup} style={{ marginTop: "10px" }}>
      <Grid
        container
        spacing={1}
        className={styles.myGrid}
        style={{
          marginTop: "10px",
        }}
        columns={12}
      >
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>From Date</label>
            </div>
            <div className={styles.formDiv}>
              <CustomDatePicker
                autoOk
                clearable
                inputVariant="outlined"
                inputProps={{
                  className: clsx(styles.select, styles.dateInput),
                }}
                onChange={(e) => handleOnclickDate(e)}
                value={fromDate}
                emptyLabel="dd/mm/yyyy"
                format="DD/MM/yyyy"
                data-testid="date-picker-div-1"
                style={{ width: "100%" }}
              />
            </div>
          </div>
        </Grid>

        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>To Date</label>
            </div>
            <div className={styles.formDiv}>
              <CustomDatePicker
                inputProps={{
                  className: clsx(styles.select, styles.dateInput),
                }}
                autoOk
                clearable
                inputVariant="outlined"
                onChange={(date) => setToDate(date)}
                value={toDate}
                emptyLabel="dd/mm/yyyy"
                format="DD/MM/yyyy"
                data-testid="date-picker-div-1"
                style={{ width: "100%" }}
              />
            </div>
          </div>
        </Grid>
        <Grid item md={4} lg={4} xs={4} sm={4}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv}>
              <Button
                style={{ color: "black", backgroundColor: "#E6F2FF" }}
                onClick={() => {
                  getSwapDetails();
                }}
                data-testid="confirm-action"
              >
                Book
              </Button>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
 
  const isScrollBar = isMobileDevice ?  styles.scrollBar : "";

  const renderAttendanceDetails = () => (
    <div className={styles.formGroup} style={{ marginTop: "10px" }}>
      <label style={{ color: "#f17c7c", fontWeight: "bold" }}>
        Total Bookable Hrs : {myState.totalHours || ""}
      </label>
      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px" }}
        className={clsx(
          styles.myGrid,
          isScrollBar
        )}
        columns={12}
      >
      <Grid item md={12} lg={12}>
      {swapDates.length > 0 && (
        <TableSimple
          tableColumnData={swapDatesTemp}
          tableHeaderLabel={swapDatesColumnTemp}
          TableRowHederAling="start"
          size="small"
          headerColor="#E6F2FF"
          className="custom-table"
        />
      )}
      </Grid>
      </Grid>
      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px" }}
        className={clsx(
          styles.myGrid,
          isScrollBar
        )}
        columns={12}
      >
        <Grid item md={12} lg={12} sm={12} xs={12}>
          <TableSimple
            tableColumnData={existingData.map((info, index) => ({
              projectType: info.project_type,
              barrel: info.barrel,
              projectDetails: info.project_details,
              evmActivity: info.evm_activity,
              module: info.module_mfl,
              hrs: info.hrs,
              action: (
                <>
                  <IconButton
                    style={{ color: "#f17c7c" }}
                    className={styles.deleteIcon}
                    onClick={() => {
                      handleDelete(index);
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </>
              ),
            }))}
             tableHeaderLabel= {isMobileDevice ? 
              [
              "Project / Indirect Project_80",
              "Barrel_110",
              "Project/Indirect Details_120",
              "Gate (EVM Activity)_120",
              "Module (MFL)_80",
              "Hrs_50",
              "Action_40",
            ] : 
            [
              "Project / Indirect Project_80",
              "Barrel_110",
              "Project/Indirect Details_120",
              "Gate (EVM Activity)_120",
              "Module (MFL)_80",
              "Hrs_30",
              "Action_30",
            ]
          }
            TableRowHederAling="start"
            size="small"
            headerColor="#E6F2FF"
            className="custom-table"
          />
        </Grid>
      </Grid>
      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px" }}
        className={styles.myGrid}
        columns={12}
      >
        <Grid item md={1} lg={1}>
          <Button
            style={{ color: "black", backgroundColor: "#E6F2FF" }}
            disabled={myState.remainingHours === 0}
            onClick={() => {
              addRow(existingData.length);
            }}
            data-testid="confirm-action"
          >
            +
          </Button>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px", justifyContent: "flex-end" }}
        className={styles.myGrid}
        columns={12}
      >
        <Grid item md={3} lg={3}>
          <TableSimple
            tableColumnData={[
              {
                label: "Total Hrs Booked",
                value: myState?.bookedHours ? myState?.bookedHours : 0,
              },
              {
                label: "Hrs Remaining",
                value: myState?.remainingHours
                  ? myState?.remainingHours
                  : myState?.remainingHours === 0
                  ? 0
                  : myState?.totalHours,
              },
            ]}
            tableHeaderLabel={["", ""]}
            TableRowHederAling="left"
            size="small"
            headerColor="#E6F2FF"
            className="custom-table"
          />
        </Grid>
      </Grid>
      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px", justifyContent: "center" }}
        className={styles.myGrid}
        columns={12}
      >
        <Grid item md={2} lg={2}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv}>
              <Button
                className={clsx(
                  styles.actionButton,
                  styles.primaryActionButton
                )}
                variant="primary"
                disabled={
                  myState?.bookedHours === "" || myState?.bookedHours === 0 ||
                  (myState?.bookedHours !== myState?.totalHours &&
                    myState.remainingHours > 0)
                }
                data-testid="confirm-action"
                style={{ marginRight: "5px" }}
                onClick={(e) => {
                  e.preventDefault();
                  saveTimeBooking();
                }}
              >
                Save
              </Button>

              <Button
                className={clsx(styles.actionButton, styles.resetButton)}
                variant="tertiary"
                onClick={(e) => {
                  e.preventDefault();
                  resetState();
                }}
                style={{ marginRight: "5px" }}
              >
                Cancel
              </Button>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );

  return (
    <>
      <div className={styles.container} style={{ boxSizing: "border-box" }}>
        <div
          className={styles.backButtonLastRefreshedDateWrapper}
          style={{ display: "none" }}
        >
          <BackButton
            action="Back"
            handleClick={redirectToApplicationLandingPage}
          />
        </div>
        <div className={styles.processHeader}>
          <div className={styles.CustomTabClass}>
            <CustomTab title="Time Booking" withOutCount isSelected />
          </div>
          <div className={styles.processTopbar}>
            <UserInfoPanel
              userInfo={[
                {
                  Name: "Aditya Mathur",
                  "SAP ID": 122355,
                  "BC No": "122355",
                  LOC: "Engineering and Research Center",
                },
              ]}
            />
          </div>
        </div>

        <div
          className={clsx(
            styles.scrollContainer,
            styles.scrollBar,
            styles.formContainer
          )}
        >
          {datesComingFromCalendar.length === 0 ? (
            <>
              <CustomFormGroup
                header="Register Time - Individual"
                body={renderDatesToBook()}
              />
              {bookButtonClicked && <>{renderAttendanceDetails()}</>}
            </>
          ) : (
            <>
              <CustomFormGroup
                header="Register Time - Individual"
                body={renderAttendanceDetails()}
              />
            </>
          )}
        </div>

        {flag && (
          <div
            className={styles.tableView}
            style={{ height: "86%", padding: "0 2em" }}
          ></div>
        )}
         {loading==true || barrelLoading == true ? 
          <div style={{textAlign:"center",display:"flex",justifyContent:"center",marginTop:"10px",background:"white", boxShadow:"0px 3px 6px #00000027"}}>
               <Truckloading />
            </div>:''}  
      </div>
    </>
  );
};

export default withAllowedOperationsProvider(
  BatchTimeBooking,
  RESOURCE_TYPE.PROJECT
);
